<!-- Invisível: só aplica a paleta configurada, já que esta página não tem topbar. -->
<app-configurator />

<div class="min-h-screen w-full flex items-center justify-center bg-surface-50 dark:bg-surface-950 px-4 py-10">
    <div class="w-full max-w-[28rem] bg-surface-0 dark:bg-surface-900 rounded-2xl shadow-sm border border-surface-200 dark:border-surface-700 p-8">
        <div class="flex items-center gap-3 mb-8">
            <span class="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-primary text-primary-contrast" aria-hidden="true">
                <svg viewBox="0 0 32 32" width="22" height="22" fill="none">
                    <path d="M16 28V9" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" />
                    <path d="M16 17c-4.5 0-7.5-3-8-8 4.5 0 7.5 3 8 8Z" fill="currentColor" />
                    <path d="M16 13c4.5 0 7.5-3 8-8-4.5 0-7.5 3-8 8Z" fill="currentColor" opacity=".7" />
                    <path d="M16 23c4 0 6.5-2.4 7-6.5-4 0-6.5 2.4-7 6.5Z" fill="currentColor" opacity=".85" />
                </svg>
            </span>
            <span class="text-xl font-semibold tracking-tight text-surface-900 dark:text-surface-0"><span class="text-orange-500">LX</span>Harvest</span>
        </div>

        @switch (estado()) {
            @case ('carregando') {
                <div class="flex justify-center py-10"><p-progressSpinner strokeWidth="4" [style]="{ width: '2.5rem', height: '2.5rem' }" ariaLabel="Conferindo o link" /></div>
            }
            @case ('invalido') {
                <h1 class="text-2xl font-semibold tracking-tight text-surface-900 dark:text-surface-0 m-0">Link inválido ou expirado</h1>
                <p class="text-muted-color mt-3 mb-6">Este link já foi usado, foi substituído por um mais novo ou passou do prazo. Peça um novo link ao administrador do sistema.</p>
                <p-button label="Ir para o login" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/auth/login" />
            }
            @case ('valido') {
                <h1 class="text-2xl font-semibold tracking-tight text-surface-900 dark:text-surface-0 m-0">{{ convite ? 'Defina sua senha' : 'Redefina sua senha' }}</h1>
                <p class="text-muted-color mt-2 mb-6">
                    Olá, {{ link()!.nome }}. {{ convite ? 'Crie a senha para acessar o LXHarvest' : 'Crie uma nova senha' }} com o e-mail
                    <strong class="text-surface-900 dark:text-surface-0">{{ link()!.email }}</strong>.
                    O link vale até {{ link()!.expiraEm | date: 'dd/MM/yyyy HH:mm' }}.
                </p>

                <form [formGroup]="form" (ngSubmit)="salvar()" class="flex flex-col gap-5" novalidate>
                    <!-- Para o gerenciador de senhas do navegador associar a senha ao e-mail -->
                    <input type="email" autocomplete="username" [value]="link()!.email" class="hidden" aria-hidden="true" tabindex="-1" readonly />
                    <div class="flex flex-col gap-2">
                        <label for="nova-senha" class="text-sm font-medium text-surface-700 dark:text-surface-200">Nova senha</label>
                        <p-password inputId="nova-senha" formControlName="novaSenha" autocomplete="new-password" [toggleMask]="true" [fluid]="true" [feedback]="false" />
                        @if (invalido('novaSenha')) { <small class="text-red-500">Use de {{ minimo }} a 72 caracteres.</small> }
                        @else { <small class="text-muted-color">Pelo menos {{ minimo }} caracteres.</small> }
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="confirmacao" class="text-sm font-medium text-surface-700 dark:text-surface-200">Confirme a nova senha</label>
                        <p-password inputId="confirmacao" formControlName="confirmacao" autocomplete="new-password" [toggleMask]="true" [fluid]="true" [feedback]="false" />
                        @if (form.hasError('senhasDiferentes') && form.get('confirmacao')!.touched) { <small class="text-red-500">As senhas não coincidem.</small> }
                    </div>
                    @if (erro) { <p-message severity="error" [text]="erro" /> }
                    <p-button [label]="convite ? 'Definir senha' : 'Redefinir senha'" icon="pi pi-check" styleClass="w-full mt-1" size="large" type="submit" [loading]="salvando" />
                </form>
            }
        }
    </div>
</div>
